<template>
    <div>
        <Card>
            <p slot="title">
                Jatuh Tempo
            </p>

            <Button-group slot="extra">
                <Button type="primary" @click="searchByDept" icon="ios-search" size="small">
                    <span>Search By Dept</span>
                </Button>

                <Button type="primary" @click="searchByMarking" icon="ios-search" size="small">
                    <span>Search By Marking</span>
                </Button>
                <!-- @click="getUnsettledXls"  -->
                <Button type="success" icon="ios-download-outline" @click="searchByDetail" size="small">
                    Excel
                </Button>
                <!-- <Button
                    type="success"
                    icon="ios-download-outline"
                    @click="getUnsettledGroupMarkingXls"
                    size="small"  >
                        By Marking
                </Button>                 -->
            </Button-group>
            <div v-if="searchBy == 'dept'">
                <Row type="flex" justify="start" class="code-row-bg">
                    <Col span="4">
                    <Select v-model="searchSelectDepartement" placeholder="Dept. Item">
                        <Option v-for="dept, idx in departements" :value="dept.id" :key="idx">
                            {{ dept.deptName }}
                        </Option>
                    </Select>
                    </Col>
                    <Col span="1">
                    </Col>
                    <Col span="2">
                    <Select v-model="searchSelectSubbranch" disabled placeholder="Branchcode">
                        <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                            {{ subbranch.subbranchname }}
                        </Option>
                    </Select>
                    </Col>
                    <Col span="1">
                    </Col>
                    <Col span="4">
                    <Button type="primary" :loading="loadingGetUnSettled" icon="ios-search-strong"
                        v-if="searchSelectDepartement != ''" @click="getUnsettledHeader">
                        <span v-if="!loadingGetUnSettled">Cari</span>
                        <span v-else>Wait.</span>
                    </Button>
                    </Col>

                </Row>
                <br />
                <Card v-if="invoiceGrouped != ''">
                    <Tabs :animated="false" @on-click="getPeriode">
                        <TabPane v-for="(period, index) in invoiceGrouped" :key="period.periodMonth + period.periodYear"
                            :label="period.periodLabel">
                            <Spin size="large" v-show="loadingDetail"></Spin>
                            <cInvoiceUnSettledByPeriod v-if="invoiceGroupedHeader[index]"
                                :invoiceDues="invoiceGroupedHeader[index]" @onAddNotes="onAddNotes"
                                @getUnsettledDetail="getUnsettledDetail">
                            </cInvoiceUnSettledByPeriod>
                        </TabPane>
                    </Tabs>
                </Card>
                <div class="footer" v-show="newNotes.length > 0">
                    <Button type="primary" :loading="loadingPost" @click="postNotes" icon="checkmark-round"
                        size="small">
                        <span>Simpan</span>
                    </Button>
                </div>
            </div>
            <div v-if="searchBy == 'marking'">
                <Row>
                    <Col span="5">
                    <Select style="width: 250px;" placeholder="Ketik Marking" v-model="markingIdSelected" filterable
                        clearable remote :remote-method="getMarkingByCode" :loading="loadingGetMarking"
                        @on-change="getUnSettledByMarking">
                        <Option v-for="(option, index) in optionMarkings" :value="option.value" :key="index">
                            {{ option.label }}</Option>
                    </Select>
                    </Col>
                    <Col span="1" offset="1">
                    <Spin size="large" v-show="loadingGetUnsettledByMarking"></Spin>
                    </Col>
                </Row>
                <br />
                <div v-if="invoiceGrouped != ''">
                    <div v-for="(item, i) in invoiceGrouped" :key="i">
                        <cInvoiceUnSettledByMarking :item="item"></cInvoiceUnSettledByMarking>
                        <br />
                    </div>
                </div>
            </div>
            <span v-if="searchBy == 'detail'">
                  <Row type="flex">
                      <Col span="5">
                      <Select v-model="itemDeptId" placeholder="Department" clearable filterable>
                          <Option v-for="itemDept in itemsDept" :value="itemDept.id" :key="itemDept.id">{{
                              itemDept.value }}</Option>
                      </Select>
                      </Col>
                      <Col span="1">
                          </Col>
                      <Col span="2">
                      <Select v-model="branchSelected" name="branchSelected" placeholder="Branch" clearable filterable>
                          <Option v-for="type in branchList" :value="type.value" :key="type.value">
                              {{ type.label }}
                          </Option>
                      </Select>
                      </Col>
                  </Row>
            </span>
            <br />
            <Card v-if="searchBy == 'detail'">
                By Departements
                <div>
                    <Row type="flex" justify="start" class="code-row-bg">
                        <Col span="5" v-if="detailExcelDate">
                        <Button type="success" :loading="loadingGetUnSettled" icon="ios-download-outline"
                            @click="getXlsFromStorage">
                            <span v-if="!loadingGetUnSettled">Download</span>
                            <span v-else>Wait.</span>
                        </Button>
                        </Col>
                        <Col span="5">
                        <Button type="primary" :loading="loadingGetUnSettled" icon="ios-search-strong"
                            @click="getUnsettledXlsNew">
                            <span v-if="!loadingGetUnSettled">Generate</span>
                            <span v-else>Wait.</span>
                        </Button>
                        </Col>
                    </Row>
                    <Row type="flex" justify="start" class="code-row-bg">
                        <Col span="5">
                        <span style="font-size: 0.75em"> Detail : {{ this.detailExcelDate }} </span>
                        </Col>
                    </Row>

                    <br />
                </div>
            </Card>
            <Card v-if="searchBy == 'detail'">
                By Markings
                <div>
                    <Row type="flex" justify="start" class="code-row-bg">
                        <Col span="5" v-if="detailExcelDateMarking">
                            <Button
                                type="success"
                                :loading="loadingGetUnSettled"
                                icon="ios-download-outline"
                                @click="getXlsFromStorageMarking"
                            >
                                <span v-if="!loadingGetUnSettled">Download</span>
                                <span v-else>Wait...</span>
                            </Button>
                        </Col>
                        <Col span="5">
                        <Button type="primary" :loading="loadingGetUnSettled" icon="ios-search-strong"
                            @click="getUnsettledXlsMarkingNew">
                            <span v-if="!loadingGetUnSettled">Generate</span>
                            <span v-else>Wait.</span>
                        </Button>
                        </Col>
                    </Row>
                    <Row type="flex" justify="start" class="code-row-bg">
                        <Col span="5">
                        <span style="font-size: 0.75em"> Detail : {{ this.detailExcelDateMarking }} </span>
                        </Col>
                    </Row>
                    <br />
                </div>
            </Card>
            <Card v-if="searchBy == 'detail'">
                By Markings
                <div>
                    <Row type="flex" justify="start" class="code-row-bg">
                        <Col span="5" v-if="detailExcelDateMarking">
                            <Button
                                type="success"
                                :loading="loadingGetUnSettled"
                                icon="ios-download-outline"
                                @click="getXlsFromStorageMarkingV2"
                                style="margin-left: 8px"
                            >
                                <span v-if="!loadingGetUnSettled">Download v2</span>
                                <span v-else>Wait...</span>
                            </Button>
                        </Col>
                        <Col span="5">
                        <Button type="primary" :loading="loadingGetUnSettled" icon="ios-search-strong"
                            @click="getUnsettledXlsMarkingNewV2">
                            <span v-if="!loadingGetUnSettled">Generate</span>
                            <span v-else>Wait.</span>
                        </Button>
                        </Col>
                    </Row>
                    <Row type="flex" justify="start" class="code-row-bg">
                        <Col span="5">
                        <span style="font-size: 0.75em"> Detail : {{ this.detailExcelDateMarking }} </span>
                        </Col>
                    </Row>
                    <br />
                </div>
            </Card>
        </Card>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import cInvoiceUnSettledByMarking from '@/components/invoice/cInvoiceUnSettledByMarking'
import cInvoiceUnSettledByPeriod from '@/components/invoice/cInvoiceUnSettledByPeriod'
import _ from 'lodash'

let serverIP = localStorage.getItem('serverIP')

export default {
    components: { cInvoiceUnSettledByPeriod, cInvoiceUnSettledByMarking },
    data: () => ({
        byMonths: [],
        invoiceGrouped: [],
        invoiceGroupedDetail: [],
        invoiceGroupedHeader: [],
        newNotes: [],
        loadingDetail: false,
        loadingPost: false,
        loadingGetUnSettled: false,
        searchSelectDepartement: '',
        searchSelectSubbranch: localStorage.getItem('user.subbranchcode'),
        subbranchcode: localStorage.getItem('user.subbranchcode'),
        branchSelected: localStorage.getItem('user.subbranchcode'),
        username: localStorage.getItem('user.username'),
        getMonths: [],
        getYears: [],
        departements: '',
        subbranchs: '',
        searchBy: '',
        byMonths: [],
        markingIdSelected: '',
        loadingGetMarking: false,
        optionMarkings: [],
        loadingGetUnsettledByMarking: false,
        detailExcelDate: '',
        detailExcelDateMarking: '',
        itemDeptId: null,
        itemsDept: [
            {
                id : 'FCL',
                value : 'FCL'
            },
            {
                id : 'LCL',
                value : 'LCL'
            },
            {
                id : 'UDARA',
                value : 'UDARA'
            }
        ],
        branchList: [],
    }),
    methods: {
        getPeriode: function (i) {
            //console.log(this.invoiceGroupedHeader[0]);
            if (this.invoiceGroupedHeader[i] == true) {
                this.getUnsettledDetail(this.getMonths[i], this.getYears[i], i)
            }
            //console.log("lola", i)
        },
        searchByDept: function () {
            this.searchBy = "dept";
            this.byMonths = [];
            this.invoiceGrouped = [];
            this.loadingSearch = false;
        },
        searchByMarking: function () {
            this.searchBy = "marking";
            this.invoiceGrouped = [];
            this.markingIdSelected = '';
            this.optionMarkings = [];
        },
        searchByDetail: function () {
            this.searchBy = "detail";
            this.invoiceGrouped = [];
            this.markingIdSelected = '';
            this.optionMarkings = [];
            this.getXlsDetail();
            this.getXlsDetailMarking();
        },
        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.subbranchcode
                        })
                        .then(response => {

                            // this.invoiceDues = []
                            // this.amountResidue = ''
                            // this.amountReceived = ''
                            // this.description = ''

                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),

        getUnSettledByMarking: function () {
            if (this.markingIdSelected != '') {
                this.loadingGetUnsettledByMarking = true;
                HTTP
                    .get('invoiceDue/unsettled/' + this.markingIdSelected)
                    .then(response => {

                        this.byMonths = []

                        //let invoiceGrouped = groupBy(response.data, 'receivable.invoice.packaging_list.marking_minified.markingheadercode', 'markingheadercode', 'invoices')
                        let invoiceGrouped = groupBy(response.data, 'receivable.marking_minified.markingheadercode', 'markingheadercode', 'invoices')

                        invoiceGrouped =
                            //_.sortBy(invoiceGrouped, ['markingheadercode']);
                            _.sortBy(invoiceGrouped, ['markingheadercode']);


                        this.invoiceGrouped = invoiceGrouped

                        this.loadingGetUnsettledByMarking = false;
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
            }
        },
        getUnsettled: function () {
            this.loadingGetUnSettled = true;
            this.invoiceGrouped = []

            HTTP
                //.get('invoiceDue/unsettled')
                .get('invoiceDue/report/json/' + this.searchSelectDepartement)
                .then(response => {

                    this.newNotes = []
                    this.byMonths = []

                    let invoiceGrouped = response.data;

                    let parent = this
                    _.forEach(invoiceGrouped, function (invGrouped, i) {
                        invoiceGrouped[i].periodLabel = parent.getMonthName(invoiceGrouped[i].periodMonth) + ' ' + invoiceGrouped[i].periodYear
                        var invoiceDues = invoiceGrouped[i].invoiceDues;
                        var totalRemainingFeeOfMonth = 0;
                        _.forEach(invoiceDues, function (data, x) {
                            if (data.length !== undefined) {
                                var totalRemainingFee = data[data.length - 1]['totalRemainingFee'];
                                totalRemainingFeeOfMonth += totalRemainingFee;
                            } else {
                                var objLen = Object.keys(data).length - 1;
                                var totalRemainingFee = data[objLen].totalRemainingFee;
                                totalRemainingFeeOfMonth += totalRemainingFee;
                            }
                        });
                        invoiceGrouped[i].invoiceDues.totalRemainingFeeOfMonth = totalRemainingFeeOfMonth.toString();
                    });

                    this.invoiceGrouped = invoiceGrouped

                    this.loadingGetUnSettled = false;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getUnsettledHeader: function () {
            this.loadingGetUnSettled = true;
            this.invoiceGrouped = []
            this.getMonths = []
            this.getYears = []

            HTTP
                //.get('invoiceDue/unsettled')
                .get('invoiceDue/reportHeader/' + this.searchSelectDepartement + '/' + this.searchSelectSubbranch)
                .then(response => {
                    this.newNotes = []
                    this.byMonths = []


                    let invoiceGrouped = response.data;
                    let parent = this
                    _.forEach(invoiceGrouped, function (invGrouped, i) {
                        invoiceGrouped[i].periodLabel = parent.getMonthName(invoiceGrouped[i].periodMonth) + ' ' + invoiceGrouped[i].periodYear
                        parent.getMonths[i] = invoiceGrouped[i].periodMonth
                        parent.getYears[i] = invoiceGrouped[i].periodYear
                        parent.invoiceGroupedHeader[i] = true
                    });

                    //console.log(this.invoiceGroupedHeader);
                    this.invoiceGrouped = invoiceGrouped
                    this.loadingGetUnSettled = false;
                    if (this.invoiceGrouped != "") {
                        this.getUnsettledDetail(this.getMonths[0], this.getYears[0], 0)
                    }
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getUnsettledDetail: function (month, years, index) {
            this.loadingGetUnSettled = true;
            this.loadingDetail = true;

            HTTP
                .get('invoiceDue/reportDetail/' + this.searchSelectDepartement + '/' + years + '/' + month + '/' + this.searchSelectSubbranch)
                .then(response => {
                    // this.newNotes = []
                    // this.byMonths = []

                    let invoiceGroupedDetail = response.data;
                    let parent = this
                    // _.forEach(invoiceGroupedDetail, function(invGrouped, i) {
                    //     invoiceGroupedDetail[i].periodLabel = parent.getMonthName(invoiceGroupedDetail[i].periodMonth) + ' ' + invoiceGroupedDetail[i].periodYear
                    var invoiceDues = invoiceGroupedDetail[0].invoiceDues;
                    var totalRemainingFeeOfMonth = 0;
                    _.forEach(invoiceDues, function (data, x) {
                        if (data.length !== undefined) {
                            var totalRemainingFee = data[data.length - 1]['totalRemainingFee'];
                            totalRemainingFeeOfMonth += totalRemainingFee;
                        } else {
                            var objLen = Object.keys(data).length - 1;
                            var totalRemainingFee = data[objLen].totalRemainingFee;
                            totalRemainingFeeOfMonth += totalRemainingFee;
                        }
                    });
                    invoiceGroupedDetail[0].invoiceDues.totalRemainingFeeOfMonth = totalRemainingFeeOfMonth.toString();
                    invoiceGroupedDetail[0].index = index;
                    // });

                    this.invoiceGroupedDetail = invoiceGroupedDetail
                    this.invoiceGroupedHeader[index] = invoiceGroupedDetail[0]
                    //console.log(this.invoiceGroupedHeader);
                    this.loadingGetUnSettled = false;
                    this.loadingDetail = false;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getXlsDetail: function () {
            HTTP
                .get('invoiceDue/getDetailExcel')
                .then(response => {
                    this.detailExcelDate = response.data;

                })
                .catch(e => {
                    this.detailExcelDate = false
                    // this.$Notice.error({
                    //     title: "Error",
                    //     desc: e,
                    //     duration: 5
                    // });
                })
        },
        getXlsDetailMarking: function () {
            HTTP
                .get('invoiceDue/getDetailExcelMarking')
                .then(response => {
                    this.detailExcelDateMarking = response.data;
                })
                .catch(e => {
                    this.detailExcelDateMarking = false
                    // this.$Notice.error({
                    //     title: "Error",
                    //     desc: e,
                    //     duration: 5
                    // });
                })
        },
        getUnsettledXls: function () {
            // this.loadingGetUnSettled = true;
            // let url = 'http://' + serverIP + 'invoiceDue/report';
            // window.open(url, '_blank');
            this.loadingGetUnSettled = true;

            HTTP
                .get('invoiceDue/report/' + this.subbranchcode)
                .then(response => {
                    this.detailExcelDate = response.data;
                    this.loadingGetUnSettled = false;
                    this.getXlsDetail();
                    this.getXlsDetailMarking();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getUnsettledXlsNew: function () {
            this.loadingGetUnSettled = true;

            let payload = {
              subbranchcode : this.branchSelected,
              itemDeptId : this.itemDeptId
            }
            HTTP
                .post('invoiceDue/report-by-department', payload)
                .then(response => {
                    this.detailExcelDate = response.data;
                    this.loadingGetUnSettled = false;
                    this.getXlsDetail();
                    this.getXlsDetailMarking();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })

                this.loadingGetUnSettled = true;
        },
        getUnsettledXlsMarking: function () {
            this.loadingGetUnSettled = true;
            HTTP
                .get('invoiceDue/reportGroupMarking/' + this.subbranchcode)
                .then(response => {
                    this.detailExcelDate = response.data;
                    this.loadingGetUnSettled = false;
                    this.getXlsDetailMarking();
                    this.getXlsDetail();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getUnsettledXlsMarkingNew: function () {
            this.loadingGetUnSettled = true;
            let payload = {
              subbranchcode : this.branchSelected,
              itemDeptId : this.itemDeptId
            }

            HTTP
                .post('invoiceDue/report-by-marking', payload)
                .then(response => {
                    this.detailExcelDate = response.data;
                    this.loadingGetUnSettled = false;
                    this.getXlsDetailMarking();
                    this.getXlsDetail();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getUnsettledXlsMarkingNewV2: function () {
            this.loadingGetUnSettled = true;
            let payload = {
              subbranchcode : this.branchSelected,
              itemDeptId : this.itemDeptId
            }

            HTTP
                .post('invoiceDue/report-by-markingv2', payload)
                .then(response => {
                    this.detailExcelDate = response.data;
                    this.loadingGetUnSettled = false;
                    this.getXlsDetailMarking();
                    this.getXlsDetail();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getXlsFromStorage: function () {
            let url = 'https://' + serverIP + 'invoiceDue/getExcel/' + localStorage.getItem('user.country');
            window.open(url, '_blank');
        },
        getXlsFromStorageMarking: function () {
            let url = 'https://' + serverIP + 'invoiceDue/getExcelMarking/' + localStorage.getItem('user.country');
            window.open(url, '_blank');
        },
        getXlsFromStorageMarkingV2: function () {
            let url = 'https://' + serverIP + 'invoiceDue/getExcelMarkingV2/' + localStorage.getItem('user.country');
            window.open(url, '_blank');
        },
        getUnsettledGroupMarkingXls: function () {
            let url = 'https://' + serverIP + 'invoiceDue/reportGroupMarking';
            window.open(url, '_blank');
        },
        getUnsettledGroupMarkingXlsNew: function () {
            let url = 'https://' + serverIP + 'invoiceDue/generate-due-date';
            window.open(url, '_blank');
        },
        onAddNotes: function (newNotes) {
            var index = _.findIndex(this.newNotes, { invoiceDueId: newNotes.invoiceDueId });

            if (index == -1)
                this.newNotes.push(newNotes)

            // notes empty, remove from array...
            if (newNotes.notes == '') {
                this.newNotes.splice(index, 1)
            } else {
                // Add notes..
                // Replace item at index using native splice
                this.newNotes.splice(index, 1, newNotes);
            }
        },

        postNotes: function () {
            this.loadingPost = true

            HTTP
                .post('invoiceDueNotes/create', {
                    notes: this.newNotes
                })
                .then(response => {
                    this.loadingPost = false
                    this.newNotes = [];
                    this.invoiceGrouped = [];

                    this.$Message.success({
                        content: 'Notes Saved',
                        duration: 3
                    });

                    this.getUnsettledHeader();
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })

        },
        getDepartement: function () {
            HTTP
                .get('itemDept')
                .then(response => {
                    this.departements = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getSubbranch: function () {
            HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getBranchList: function () {
            let parent = this;
            HTTP
                .get('subbranch')
                .then(response => {
                    console.log({ response });
                    let branchList = []
                    let isSupervisor = ["WILYA-FA", "SURYANTI", "SUSAN", "INDRA", "SURINDA", "LINDA", "ADRI", "ERIC", "SYSTEM"].includes(this.username);
                    let temp = {};

                    if(isSupervisor) {
                      temp = {
                          value: "All",
                          label: "All"
                      }

                      branchList.push(temp);
                    }

                    _.forEach(response.data, function (value) {
                      console.log(parent.subbranchcode);
                      if(isSupervisor) {
                        temp = {
                            value: value.subbranchcode,
                            label: value.subbranchname
                        }

                        branchList.push(temp);
                      } else if(parent.subbranchcode == value.subbranchcode) {
                        temp = {
                            value: value.subbranchcode,
                            label: value.subbranchname
                        }

                        branchList.push(temp);
                      } else if (parent.subbranchcode == 'SBY' && value.subbranchcode == 'BALI') {
                        temp = {
                            value: value.subbranchcode,
                            label: value.subbranchname
                        }

                        branchList.push(temp);
                      }
                    });

                    parent.branchList = branchList;
                    console.info(parent.branchList);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getMonthName: function (monthInt) {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
            return monthNames[monthInt - 1]
        },

    },
    //   const monthNames = ["January", "February", "March", "April", "May", "June",
    //   "July", "August", "September", "October", "November", "December"
    // ];

    created() {
        // this.getUnreceived();
        // console.log('get unsettled')
        this.getDepartement();
        this.getSubbranch();
        this.getBranchList();
    }
}

function groupBy(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
        .groupBy(fieldNameToGroupOn)
        .toPairs()
        .map(function (currentItem) {
            return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
        })
        .value();
    return result;
}
</script>
<style></style>



// WEBPACK FOOTER //
// InvoiceUnSettled.vue?77ebd4d0